module.exports = __webpack_public_path__ + "img/labels-3-d-desktop@2x.68c9adcf.webp";